import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { ProductionOrderService, ProductionOrderId } from './production-order.service';

import { Globals, Ref } from '../globals';
import { firestore } from 'firebase/app';
import { Currency } from './bank.service';
import { Utils } from '../util';
import { Upload } from './upload/upload';
import * as firebase from 'firebase';
import { IncomeService } from './income.service';
import { EmployeeId } from './employee.service';
import { CustomerSupplierId } from './customer-supplier.service';
import { FiscalDataId } from './fiscal-data.service';
import { CompanyData, CompanyId } from './company.service';
import { PrVntaData } from './product-vnta.service';
import { PayrollId } from './catalogs-settings.service';

export interface CustomerBill {
  active: number;
  createdAt: any;
  updatedAt: any;

  customerRef: any;
  customerId: string;
  fiscalDataRef: any;
  productionOrderRef: any;
  employeeRef?: Ref;
  extraFiscalDataId: string;
  
  date: string;
  folio: number;
  payDate: string;
  receptionDate: string;
  notes: string;

  prForBills: PrForBill[];
  creditNotes: CreditNote[];
  cnLength: number;
  /* complements: Complement[]; */

  cfdi: CFDI;

  status: keyof (typeof Globals)['BILL_STATUS'];
  uuid: string;
  _stampedByMedicosproBackendServer?: boolean;

  totals: {
    amountNoDisc: number,
    creditNote: number,
    iva: number,
    retIsr: number,
    retIva: number,
    subtotal: number,
    total: number,
  };
  incomeds: Incomed[];

  id: string;
  Timbrado_xml: BucketFile;
  Timbrado_pdf: BucketFile;
  Cancelado_xml: BucketFile;
  Cancelado_pdf: BucketFile;

  currency: keyof CustomerBillData['currencySelect'];
  change: number;

  associatedBillId: string;
  associatedRelationType: keyof CustomerBillData['associatedRelationTypes'];
  associatedToBillId: string;

  lastBias?: {value: number, incomeId: string};
  stampedIncomes?: { incomeId: string, bias: number, amount: number, extraBias: number, extraAmount: number }[];
}

export interface BillFile{
  Timbrado_xml?: BucketFile;
  Timbrado_pdf?: BucketFile;
  Cancelado_xml?: BucketFile;
  Cancelado_pdf?: BucketFile;
}

export interface CustomerBillId extends CustomerBill {
  id: string;
  customerObj?: CustomerSupplierId;
  fiscalDataObj?: FiscalDataId;
  productionOrderObj?: ProductionOrderId[];
  employeeObj?: EmployeeId;
}

export interface BucketFile{
  id: string,
  path: string,
  name: string,
  url: string,
  access: 'private' | 'public',
}

export interface PrForBill {
  remissionId: string;
  odpId: string;
  odpFolio: string;
  productRef: any; isVnta?: boolean;
  product: string;
  productSatKey: keyof PrVntaData['productSatKeyObjects'];
  unitSatKey: keyof PrVntaData['unitSatKeyObjects'];
  currency: string;
  //Table
  quantity: number;
  pricePerUnit: number;
  retentionApplies: boolean;
  ivaApplies: boolean;
  discountPct: number;
  amount: number;
  amountNoDisc: number;
  retIsr: number;
  retIva: number;
  subtotal: number;
  iva: number;
  total: number;

  notes: string;
}

export interface CreditNote {
  folio: string;
  date: string;
  subtotal: number;
  iva: number;
  total: number;
  notes?: string;
  uuid: string;
  _stampedByMedicosproBackendServer?: boolean;
  cfdiRelation: string;
  status: string;
  extraUuid: string;
  isReturning: boolean;
  returnQuantity: number;
}

/* export class Complement{
  folio: string = ''; date: string; payMethod: string; currency: string; change: number; bias: number; iva: number; subtotal: number; uuid: string;
  get ivatotal(): number { return this.subtotal*this.iva/100 }; get total(): number { return this.subtotal + this.ivatotal };
  constructor(bias2:number, {folio='',date=`${Utils.today}`,payMethod='key0',currency='key0',change=1, bias,iva=16,subtotal=0,status='key0',uuid=''}: Complement={} as Complement){
    this.folio = folio; this.date = date; this.payMethod = payMethod; this.currency = currency; this.bias = bias || bias2;
    this.change = change; this.iva = iva; this.subtotal = subtotal; this.status = status; this.uuid = uuid;
  }
  status: string = 'key0';
}
Object.defineProperty(Complement.prototype, 'valid', {get: function valid(){ return !!(this.folio && this.date && this.change && this.iva && this.subtotal) }}) */

export interface Incomed {
  incomeRef: any;
  amount: number;
  extraAmount: number;
}

export interface CFDI{
  payForm: keyof CustomerBillData['payFormSelect']; // Forma de pago
  payMethod: keyof CustomerBillData['payMethodSelect']; // Método de pago
  payConditions: keyof CustomerBillData['payConditionsSelect']; // Condiciones de pago
  cfdiUsage: keyof CustomerBillData['cfdiUsageSelect']; // Uso CFDI
  currency: keyof CustomerBillData['currencySelect']; // Tipo de moneda
  change: number; // Tipo de cambio
  bankDigits: string; // Dígitos bancario
}

@Injectable()
export class CustomerBillService {

  customerBillCollection: AngularFirestoreCollection<CustomerBill>;
  customerBills: any;

  customerBillDocument: AngularFirestoreDocument<CustomerBillId>;
  customerBill: Observable<CustomerBillId>;

  collection: string;
  customerCollection: string;
  fiscalDataCollection: string;
  productionOrderCollection: string;
  employeeCollection: string;
  prVntaCollection: string;
  prCmpaCollection: string;
  incomeCollection: string;
  companyCollection: string;
  companyId: string;

  constructor(
    private afs: AngularFirestore,
    public afh: FirestoreService,
    private incomeService: IncomeService,
    private router: Router,
    private productionOrderService: ProductionOrderService
  ) {
    this.collection = Globals.CUSTOMER_BILL_COLLECTION;
    this.customerCollection = Globals.CUSTOMER_SUPPLIER_COLLECTION;
    this.fiscalDataCollection = Globals.FISCAL_DATA_COLLECTION;
    this.productionOrderCollection = Globals.PRODUCTION_ORDER_COLLECTION;
    this.employeeCollection = Globals.EMPLOYEE_COLLECTION;
    this.prVntaCollection = Globals.PRVNTA_COLLECTION;
    this.prCmpaCollection = Globals.PRCMPA_COLLECTION;
    this.incomeCollection = Globals.INCOME_COLLECTION;
    this.companyCollection = Globals.COMPANIES_COLLECTION;
    this.companyId = Globals.AGRO_VIVA_DOCUMENT_ID;
  }

  /**
   * Get all customerBills with references
   * @return {Observable} Arrays of customerBills
   */
  getCustomerBills({date='', receptionDate='', year='', customerId='', minCnLength=null, onEmpty=null, only15days=false, fetchRefs=true}={}) {
    let col;
    if(date){
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('date', 'desc').where('active', '==', true).where('date', '>=', date));
    }else if(receptionDate){
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('receptionDate', 'desc').where('active', '==', true).where('receptionDate', '>=', receptionDate));
    }else if(year){
      let s = `${year}-00-00`, e = `${year}-99-99`;
      col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('date', '>', s).where('date', '<', e) );
    }else if(minCnLength !== null){
      col = this.afh.colWithIds$(this.collection, ref => ref.where('cnLength', '>', 0) );
    }else if(customerId){
      if(only15days){
        let d = new Date();
        d.setDate(d.getDate() - 15);
        let strDate = Utils.stringDate(d);
        //console.log(strDate);
        col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('customerId', '==', customerId).where('date', '>=', strDate));
      }else{
        col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('customerId', '==', customerId));
      }
    }else{
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('date', 'desc').where('active', '==', true));
    }
    if(!fetchRefs) return col;
    return col.map(documents => {
      if(!documents.length && onEmpty) onEmpty();
      return documents.map(document => {
        let hasODP = !!document.productionOrderRef;
        let hasEmp = !! document.employeeRef;
        let customerRef = this.afh.docWithIds$(`${document.customerRef.path}`);
        //console.log(`Got bill: ${document.id}`);
        return Observable.combineLatest(
          customerRef,
          this.afh.docWithIds$(`${document.fiscalDataRef.path}`),
          hasODP ? this.productionOrderService.getProductionOrder(`${document.productionOrderRef.id}`) : customerRef,
          hasEmp ? this.afh.docWithIds$(`${document.employeeRef.path}`) : customerRef,
          (customerData, fiscalDataData, productionOrderData, employee) => ({
            customer: customerData,
            fiscalData: fiscalDataData,
            productionOrder: hasODP ? productionOrderData : undefined,
            employee: hasEmp ? employee : undefined
          })
        ).map( data => ({ customerObj: data.customer, fiscalDataObj: data.fiscalData, productionOrderObj: data.productionOrder, employeeObj: data.employee, ...document }) );
      });
    }).mergeMap(documents => Observable.combineLatest(documents));
  }

  /**
   * Get all customerBills with references within 15 days
   * @return {Observable} Arrays of customerBills
   */
  getCustomerBillsFifteenDays() {
    let filteredDate = new Date();
    filteredDate.setDate(filteredDate.getDate() - 15);
    let date = this.stringifyDate(filteredDate);
    let c = 0;
    return this.afh.colWithIds$(this.collection, ref => ref.orderBy('date', 'desc').where('active', '==', true).where('date', '>', date)).map(documents => {
      return documents.map(document => {
        let hasODP = !!document.productionOrderRef;
        let hasEmp = !! document.employeeRef;
        let customerRef = this.afh.docWithIds$(`${document.customerRef.path}`);
        return Observable.combineLatest(
          customerRef,
          this.afh.docWithIds$(`${document.fiscalDataRef.path}`),
          hasODP ? this.productionOrderService.getProductionOrder(`${document.productionOrderRef.id}`) : customerRef,
          hasEmp ? this.afh.docWithIds$(`${document.employeeRef.path}`) : customerRef,
          (customerData, fiscalDataData, productionOrderData, employee) => ({
            customer: customerData,
            fiscalData: fiscalDataData,
            productionOrder: hasODP ? productionOrderData : undefined,
            employee: hasEmp ? employee : undefined
          })
        ).map( data => ({ customerObj: data.customer, fiscalDataObj: data.fiscalData, productionOrderObj: data.productionOrder, employeeObj: data.employee, ...document }) );
      });
    }).mergeMap(documents => Observable.combineLatest(documents));
  }

  /**
  * Get customerBill data
  * @param {string} sid - The id of the customerBill
  * @return {Observable} The CustomerBill Object
  */
  getCustomerBill(sid: string) {
    return this.afh.docWithIds$(this.collection + '/' + sid).map(document => {
      let hasODP = !!document.productionOrderRef;
      let hasEmp = !! document.employeeRef;
      let hasExtraRfc = !!document.extraFiscalDataId;
      let customerRef = this.afh.docWithIds$(`${document.customerRef.path}`);
      return Observable.combineLatest(
        customerRef,
        this.afh.docWithIds$(`${document.fiscalDataRef.path}`),
        hasODP ? this.productionOrderService.getProductionOrder(`${document.productionOrderRef.id}`) : customerRef,
        hasEmp ? this.afh.docWithIds$(`${document.employeeRef.path}`) : customerRef,
        hasExtraRfc ? this.afh.docWithIds$(`${this.fiscalDataCollection}/${document.extraFiscalDataId}`) : customerRef,
        this.afh.docWithIds$(`${this.companyCollection}/${this.companyId}`),
        (customerData, fiscalDataData, productionOrderData, employee, extraFiscal, companyData) => ({
          customer: customerData,
          fiscalData: fiscalDataData,
          productionOrder: hasODP ? productionOrderData : undefined,
          employee: hasEmp ? employee : undefined,
          extraFiscal: hasExtraRfc ? extraFiscal : undefined,
          company: companyData
        })
      ).map( data => ({ customerObj: data.customer, fiscalDataObj: data.fiscalData, productionOrderObj: data.productionOrder, employeeObj: data.employee, extraFiscalObj: data.extraFiscal, companyObj: data.company, ...document }) );

    }).mergeMap(documents => Observable.combineLatest(documents));
  }
  getCustomerBillNoRec(id: string): Observable<CustomerBill>{
    return this.afh.docWithIds$(`${this.collection}/${id}`);
  }

  /**
  * Create new customerBill
  * @param {CustomerBill} customerBill - The data of the customerBill
  */
  addCustomerBill({productionOrderRef, employeeRef=<any>'', prForBills, ...customerBill}: CustomerBill) {
    customerBill.customerRef = this.afh.doc(`${this.customerCollection}/${customerBill.customerRef}`).ref;
    customerBill.fiscalDataRef = this.afh.doc(`${this.fiscalDataCollection}/${customerBill.fiscalDataRef}`).ref;
    if(productionOrderRef) productionOrderRef = this.afh.doc(`${this.productionOrderCollection}/${productionOrderRef}`).ref;
    if(employeeRef) employeeRef = this.afh.doc(`${this.employeeCollection}/${employeeRef}`).ref;
    prForBills = prForBills.map(({isVnta, productRef='', ...pr}) => ({
      productRef: productRef ? this.afh.doc(`${isVnta ? this.prVntaCollection : this.prCmpaCollection}/${productRef}`).ref : '',
      ...pr
    }) );
    
    const docId = this.afs.createId();
    const ref = this.afs.collection(this.collection).doc(docId);
    ref.set({active: true, productionOrderRef, employeeRef, prForBills, ...customerBill});
    return docId;
  }

  /**
   * Update current customerBill
   * @param {string} sid  - The id of the customerBill
   * @param {CustomerBill} customerBill - The data of the customerBill
   */
  updateCustomerBill(sid: string, {productionOrderRef, employeeRef=<any>'', prForBills, ...customerBill}: CustomerBill) {
    customerBill.customerRef = this.afh.doc(`${this.customerCollection}/${customerBill.customerRef}`).ref;
    customerBill.fiscalDataRef = this.afh.doc(`${this.fiscalDataCollection}/${customerBill.fiscalDataRef}`).ref;
    if(productionOrderRef) productionOrderRef = this.afh.doc(`${this.productionOrderCollection}/${productionOrderRef}`).ref;
    if(employeeRef) employeeRef = this.afh.doc(`${this.employeeCollection}/${employeeRef}`).ref;
    prForBills = prForBills.map(({isVnta=true, productRef='', ...pr}) => ({
      productRef: productRef ? this.afh.doc(`${isVnta ? this.prVntaCollection : this.prCmpaCollection}/${productRef}`).ref : '',
      ...pr
    }) );
    
    this.afh.update(`${this.collection}/${sid}`, {productionOrderRef, employeeRef, prForBills, ...customerBill});
  }

  updateByField(object: any, id: string){
    console.log(`Se actualizará este documento: ${this.collection}/${id}`);
    return this.afh.update(`${this.collection}/${id}`, object).then(r => {
      console.log(`Se actualizó ${id}`, object, r);
    });
  }

  get afhService(){
    return this.afh;
  }

  /**
   * Delete current customerBill
   * @param {string} sid - The id of the customerBill
   */
  deleteCustomerBill(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  uploadFile(upload: Upload, id: string, {cnI=-1, cns=[], incId='', incUuid='', onDone=()=>{}}={}) {
    const name = incId ? `${incUuid}_${Utils.arrayLast(upload.file.name.split('_'))}` : `${upload.file.name}`;
    let url = incId ? `${this.incomeCollection}/${incId}/${name}` : `${this.collection}/${id}/${name}`;
    const storageRef = firebase.storage().ref();
    console.log(`Subiendo archivo a ${url}`);
    const uploadTask = storageRef.child(`${url}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
      upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    }, (err) => {
      console.log('Error al subir');
    }, () => {
      let url = uploadTask.snapshot.downloadURL;
      let t = Utils.arrayLast(name.split('_')).replace('.','_');
      console.log(`Se subió correctamente.`)
      console.log(`Url: ${url}, Campo: ${t}`)
      if(cnI == -1 && !incId) this.updateByField({[t]: {url, name}}, id).then(r => onDone());
      else if(cnI > -1){
        cns[cnI][t] = {url, name};
        this.updateByField({ creditNotes: cns}, id).then(r => onDone());
      }else if(incId){
        let sub = this.incomeService.getIncome(incId).subscribe(([{uuidHistory={}}]) => {
          sub.unsubscribe();
          if(!uuidHistory[incUuid]) uuidHistory[incUuid] = {date: `${Utils.today} ${Utils.time}`};
          uuidHistory[incUuid][t] = {url, name};
          this.incomeService.updateByField({[t]: {url, name}, uuidHistory}, incId).then(r => onDone());
        })
      }
    });
  }

  windowReplace(action: 'add' | 'edit' | 'view' | 'read' | 'incomeAdd' | 'incomeView', id?: string){
    switch(action){
      case 'add':
        this.router.navigate([`/new_customerBill/${id}`]);
        break;
      case 'edit':
        this.router.navigate([`/edit_customerBill/${id}`]);
        break;
      case 'view':
        this.router.navigate([`/vw_customerBill/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/customerBill`]);
        break;
      case 'incomeAdd':
        this.router.navigate([`/new_income/${id}`]);
        break;
      case 'incomeView':
        this.router.navigate([`/vw_income/${id}`]);
        break;
      default:
        console.log('Not an action');
    }
  }

  defaultPrForBill: PrForBill = {
    remissionId: '',
    odpId: '',
    odpFolio: '',
    productRef: '',
    product: '',
    productSatKey: '' as keyof PrVntaData['productSatKeyObjects'],
    unitSatKey: '' as keyof PrVntaData['unitSatKeyObjects'],
    currency: 'mexicanPeso',
    //Table
    quantity: 1,
    pricePerUnit: 0,
    retentionApplies: false,
    ivaApplies: true,
    discountPct: 0,
    amount: 0,
    amountNoDisc: 0,
    retIsr: 0,
    retIva: 0,
    subtotal: 0,
    iva: 0,
    total: 0,
    notes: ''
  }

  defaultCreditNote: CreditNote = {
    folio: '',
    date: this.today,
    subtotal: 0,
    iva: 0,
    total: 0,
    uuid: '',
    cfdiRelation: 'key0',
    status: 'key0',
    extraUuid: '',
    isReturning: false,
    returnQuantity: 1,
  }


  get today(){
    return this.stringifyDate(new Date());
  }
  stringifyDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }
}

export class CustomerBillData {
  PRODUCT_ALLOWED_CHARS = [
    '-', '_', '/', '.', ',', ':', ';', '&', '(', ')', ' ',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'ñ', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'Ñ', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ];

  payFormSelect = {
    'key0':  { index: '99', name: 'Por definir', get full(){ return this.name; } },
    'key1':  { index: '01', name: 'Efectivo', get full(){ return this.name; } },
    'key2':  { index: '02', name: 'Cheque nominativo', get full(){ return this.name; } },
    'key3':  { index: '03', name: 'Transferencia electrónica de fondos', get full(){ return this.name; } },
    'key4':  { index: '04', name: 'Tarjeta de crédito', get full(){ return this.name; } },
    'key5':  { index: '05', name: 'Monedero electrónico', get full(){ return this.name; } },
    'key6':  { index: '06', name: 'Dinero electrónico', get full(){ return this.name; } },
    'key7':  { index: '08', name: 'Vales de despensa', get full(){ return this.name; } },
    'key8':  { index: '28', name: 'Tarjeta de débito', get full(){ return this.name; } },
    'key9':  { index: '29', name: 'Tarjeta de servicio', get full(){ return this.name; } },
    'key99': { index: '99', name: 'Otros', get full(){ return this.name; } },
  };// as const;
  payMethodSelect = {
    'key0': { code: '', name: '', full: ''  },
    'key1': { code: 'PUE', name: 'Pago en una sola exhibición', get full(){ return `${this.code} - ${this.name}` } },
    'key2': { code: 'PPD', name: 'Pago en parcialidades o diferido', get full(){ return `${this.code} - ${this.name}` } },
  };// as const;
  payConditionsSelect = {
    'key0': { name: '', get full(){ return this.name; } },
    'key1': { name: 'Contado', get full(){ return this.name; } },
    'key2': { name: 'Crédito', get full(){ return this.name; } },
  };// as const;
  cfdiUsageSelect = {
    'key0':  { code: '', name: '', full: ''  },
    'key1':  { code: 'G01', name: 'Adquisición de mercancias', get full(){ return `${this.code} - ${this.name}`; } },
    'key2':  { code: 'G02', name: 'Devoluciones, descuentos o bonificaciones', get full(){ return `${this.code} - ${this.name}`; } },
    'key3':  { code: 'G03', name: 'Gastos en general', get full(){ return `${this.code} - ${this.name}`; } },
    'key4':  { code: 'I01', name: 'Construcciones', get full(){ return `${this.code} - ${this.name}`; } },
    'key5':  { code: 'I02', name: 'Mobilario y equipo de oficina por inversiones', get full(){ return `${this.code} - ${this.name}`; } },
    'key6':  { code: 'I03', name: 'Equipo de transporte', get full(){ return `${this.code} - ${this.name}`; } },
    'key7':  { code: 'I04', name: 'Equipo de computo y accesorios', get full(){ return `${this.code} - ${this.name}`; } },
    'key8':  { code: 'I05', name: 'Dados, troqueles, moldes, matrices y herramental', get full(){ return `${this.code} - ${this.name}`; } },
    'key9':  { code: 'I06', name: 'Comunicaciones telefónicas', get full(){ return `${this.code} - ${this.name}`; } },
    'key10': { code: 'I07', name: 'Comunicaciones satelitales', get full(){ return `${this.code} - ${this.name}`; } },
    'key11': { code: 'I08', name: 'Otra maquinaria y equipo', get full(){ return `${this.code} - ${this.name}`; } },
    'key12': { code: 'D01', name: 'Honorarios médicos, dentales y gastos hospitalarios', get full(){ return `${this.code} - ${this.name}`; } },
    'key13': { code: 'D02', name: 'Gastos médicos por incapacidad o discapacidad', get full(){ return `${this.code} - ${this.name}`; } },
    'key14': { code: 'D03', name: 'Gastos funerales ', get full(){ return `${this.code} - ${this.name}`; } },
    'key15': { code: 'D04', name: 'Donativos ', get full(){ return `${this.code} - ${this.name}`; } },
    'key16': { code: 'D05', name: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)', get full(){ return `${this.code} - ${this.name}`; } },
    'key17': { code: 'D06', name: 'Aportaciones voluntarias al SAR', get full(){ return `${this.code} - ${this.name}`; } },
    'key18': { code: 'D07', name: 'Primas por seguros de gastos médicos', get full(){ return `${this.code} - ${this.name}`; } },
    'key19': { code: 'D08', name: 'Gastos de transportación escolar obligatoria ', get full(){ return `${this.code} - ${this.name}`; } },
    'key20': { code: 'D09', name: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones', get full(){ return `${this.code} - ${this.name}`; } },
    'key21': { code: 'D10', name: 'Pagos por servicios educativos (colegiaturas)', get full(){ return `${this.code} - ${this.name}`; } },
    'key22': { code: 'P01', name: 'Por definir', get full(){ return `${this.code} - ${this.name}`; } },
  };// as const;
  currencySelect = {
    'key0': { code: 'MXP', name: 'Peso mexicano', get full(){ return `${this.code} - ${this.name}` }  },
    'key1': { code: 'USD', name: 'Dólar americano', get full(){ return `${this.code} - ${this.name}` } },
    'key2': { code: 'EUR', name: 'Euro', get full(){ return `${this.code} - ${this.name}` } },
  };// as const;

  cnRelations = {
    key0: { index: '01', name: 'Nota de crédito de los documentos relacionados.', date:'01/01/2017' },
    key1: { index: '02', name: 'Nota de débito de los documentos relacionados.', date:'01/01/2017' },
    key2: { index: '03', name: 'Devolución de mercancía sobre facturas o traslados previos.', date:'01/01/2017' },
    key3: { index: '04', name: 'Sustitución de los CFDI previos.', date:'01/01/2017' },
    key4: { index: '05', name: 'Traslados de mercancias facturados previamente.', date:'01/01/2017' },
    key5: { index: '06', name: 'Factura generada por los traslados previos.', date:'01/01/2017' },
    key6: { index: '07', name: 'CFDI por aplicación de anticipo.', date:'13/08/2017' },
    key7: { index: '08', name: 'Factura generada por pagos en parcialidades.', date:'05/12/2017' },
    key8: { index: '09', name: 'Factura generada por pagos diferidos.', date:'05/12/2017' },
  }

  associatedRelationTypes = {
    '': 'Sin asociación',
    '01': 'Nota de crédito de los documentos relacionados.',
    '02': 'Nota de débito de los documentos relacionados.',
    '03': 'Devolución de mercancía sobre facturas o traslados previos.',
    '04':	'Sustitución de los CFDIs previos',
    '05': 'Traslados de mercancias facturados previamente.',
    '06': 'Factura generada por los traslados previos.',
    '07':	'CFDI por aplicación de anticipo',
    '08': 'Factura generada por pagos en parcialidades.',
    '09': 'Factura generada por pagos diferidos.',
  }

  allSelects = {
    payForm: Object.keys(this.payFormSelect).map(key => ({value: key, name: this.payFormSelect[key].full || '-- Seleccione una opción --'}) ),
    payMethod: Object.keys(this.payMethodSelect).map(key => ({value: key, name: this.payMethodSelect[key].full || '-- Seleccione una opción --'}) ),
    payConditions: Object.keys(this.payConditionsSelect).map(key => ({value: key, name: this.payConditionsSelect[key].full || '-- Seleccione una opción --'}) ),
    cfdiUsage: Object.keys(this.cfdiUsageSelect).map(key => ({value: key, name: this.cfdiUsageSelect[key].full || '-- Seleccione una opción --'}) ),
    currency: Object.keys(this.currencySelect).map(key => ({value: key, name: this.currencySelect[key].full || '-- Seleccione una opción --'}) ),
    cnRelations: Utils.array(this.cnRelations).map(([value, key]) => ({value: key, name: `${value.index}: ${value.name}`}) ),
    associatedRelationTypes: Utils.array(this.associatedRelationTypes).map(([name, key]) => ({value: key, name: `${key}: ${name}`}) ),
  }

  status = Globals.BILL_STATUS;

  ncFolio(ncf: string, cf: string){ return `F${cf}-N${ncf}`; }
  ncFolioR(ncf: string){ return Utils.arrayLast(ncf.split('-N')); }
}

export class CustomerBillFilter {
  allRows: any[];

  dateIndex: number;
  receptionDateIndex: number;
  customerIndex: number;
  completionIndex: number;

  constructor(allRows: any[], {dateIndex=0, receptionDateIndex=-1, customerIndex=0, completionIndex=0}){
    this.allRows = allRows;
    this.dateIndex = dateIndex;
    this.receptionDateIndex = receptionDateIndex;
    this.customerIndex = customerIndex;
    this.completionIndex = completionIndex;

    let customers = new Set( allRows.map(row => row.customerName) );
    let sortedCustomers = [...customers].sort((it1, it2) => it1 > it2 ? 1 : -1);
    this.customerSelect = ['Todos', ...sortedCustomers].map(name => ({name}) );
  }

  get filteredData() {
    return this.allRows
      .filter(({date}) => {
        if(this.receptionDateIndex != -1) return true;
        let [py, pm, pd] = date.split('-');
        let rowDate = new Date(py, pm - 1, pd);
        let filterDate = new Date();
        let {amount, unit} = this.dateSelect[this.dateIndex];
        switch(unit){
          case 'day': filterDate.setDate(filterDate.getDate() - amount); break;
          case 'month': filterDate.setMonth(filterDate.getMonth() - amount); filterDate.setDate(0); break;
          case 'year': filterDate = new Date(filterDate.getFullYear() - amount, 0); break;
          default: filterDate.setFullYear(2015); break;
        }
        if(rowDate >= filterDate) return 1;
      })
      .filter(({receptionDate}) => {
        if(this.receptionDateIndex == -1) return true;
        let [py, pm, pd] = receptionDate.split('-');
        let rowDate = new Date(py, pm - 1, pd);
        let filterDate = new Date();
        let {amount, unit} = this.dateSelect[this.receptionDateIndex];
        switch(unit){
          case 'day': filterDate.setDate(filterDate.getDate() - amount); break;
          case 'month': filterDate.setMonth(filterDate.getMonth() - amount); filterDate.setDate(0); break;
          case 'year': filterDate = new Date(filterDate.getFullYear() - amount, 0); break;
          default: filterDate.setFullYear(2015); break;
        }
        if(rowDate >= filterDate) return 1;
      })
      .filter(({customerName: rowName}) => {
        let {name: filterName} = this.customerSelect[this.customerIndex];
        if(rowName == filterName || filterName == 'Todos') return 1;
      })
      .filter(({residue}) => {
        let {name} = this.completionSelect[this.completionIndex];
        if( ( name == 'Todas' ) || ( name == 'Completadas' && residue == 0 ) || ( name == 'No completadas' && residue > 0 ) ) return 1;
      });
  }

  get json(): string {
    return JSON.stringify({
      dateIndex: this.dateIndex,
      customerIndex: this.customerIndex,
      completionIndex: this.completionIndex
    });
  }

  dateSelect = [
    { amount: 15, unit: 'day', name: '15 días' },
    { amount: 0, unit: 'month', name: 'Este mes' },
    { amount: 6, unit: 'month', name: '6 meses' },
    { amount: 0, unit: 'year', name: 'Este año' },
    { amount: 0, unit: 'forever', name: 'Siempre' },
  ];
  customerSelect = [];
  completionSelect = [
    { name: 'Todas' },
    { name: 'Completadas' },
    { name: 'No completadas' },
  ]
}

type ToFixed<T, N extends number> = string;
export type BillingJsonVersion4 = {
  Version: '4.0',
  FormaPago: CustomerBillData['payFormSelect'][CustomerBill['cfdi']['payForm']]['index'], // ej: '01'
  Serie: 'A' | 'CN' | 'P',
  Folio: ToFixed<CustomerBill['folio'], 0>, // ej: '12312'
  Fecha: CustomerBill['date'] | CustomerBill['payDate'], // format: '2022-07-14T00:00:00'
  MetodoPago: CustomerBillData['payMethodSelect'][CustomerBill['cfdi']['payMethod']]['code'], // ej: "PUE"
  Sello: string, // ej: "", se obtienen de companyFiles
  NoCertificado: string, // ej: "", se obtienen de companyFiles
  Certificado: string, // ej: "", se obtienen de companyFiles
  CondicionesDePago: CustomerBillData['payConditionsSelect'][CustomerBill['cfdi']['payConditions']]['name'], // ej: "CondicionesDePago"
  SubTotal: ToFixed<CustomerBill['totals']['subtotal' | 'amountNoDisc'], 2>, // CustomerBill['totals']['amountNoDisc'], ej: "10.00"
  Descuento: ToFixed<CustomerBill['totals']['amountNoDisc'], 2>, // ['amountNoDisc'] - ['amount'], ej: "0.00"
  Moneda: CustomerBillData['currencySelect'][CustomerBill['cfdi']['currency']]['code'], // ej: "AMD"
  TipoCambio: ToFixed<CustomerBill['cfdi']['change'], 2>, // ej: "1"
  Total: ToFixed<CustomerBill['totals']['total'], 2>, // ej: "10.00"
  TipoDeComprobante: 'I' | 'E' | 'P', //Para Factura es I, para NdC E, para complementos de pago P
  Exportacion: '01', // Significa: No Aplica
  LugarExpedicion: CompanyId['postCode'], // ej: "45610"
  Emisor: {
    Rfc: CompanyId['RFC'], // ej: "EKU9003173C9"
    Nombre: CompanyId['name'] | CompanyId['socialReason'], // ej: "ESCUELA KEMPER URGATE"
    RegimenFiscal: CompanyData['fiscalRegimenSelect'][CompanyId['fiscalRegimen']]['code'], // ej: "601"
  },
  Receptor: {
    Rfc: FiscalDataId['rfc'], // ej: "EKU9003173C9"
    Nombre: CustomerSupplierId['name'] | FiscalDataId['businessName'], // ej: "ESCUELA KEMPER URGATE"
    DomicilioFiscalReceptor: FiscalDataId['postCode'] | CompanyId['postCode'], // en caso que sea RFC Genérico XAXA00... se manda código postal del emisor
    RegimenFiscalReceptor: CompanyData['fiscalRegimenSelect'][FiscalDataId['fiscalRegimen']]['code'], // fiscalRegimenSelect[key]['code'], ej: "601"
    UsoCFDI: CustomerBillData['cfdiUsageSelect'][FiscalDataId['cfdi']['cfdiUsage']]['code'], // ej: "CP01"
  },
  Conceptos: {
    ClaveProdServ: CustomerBill['prForBills'][number]['productSatKey'], // ej: "50211503"
    NoIdentificacion: CustomerBill['prForBills'][number]['product'], // format: Utils.initials, ej: "None"
    Cantidad: ToFixed<CustomerBill['prForBills'][number]['quantity'], 1>, // ej: "1.0"
    ClaveUnidad: CustomerBill['prForBills'][number]['unitSatKey'], // ej: "H87"
    Unidad: PrVntaData['unitSatKeyObjects'][CustomerBill['prForBills'][number]['unitSatKey']]['description'], // ej: "Pieza"
    Descripcion: CustomerBill['prForBills'][number]['product'], // ej: "Cigarros"
    ValorUnitario: ToFixed<CustomerBill['prForBills'][number]['pricePerUnit'], 4>, // ej: "10.00"
    Importe: ToFixed<CustomerBill['prForBills'][number]['amountNoDisc'], 2>, // ej: "10.00"
    Descuento: ToFixed<CustomerBill['prForBills'][number]['amountNoDisc'], 2>, // ['amountNoDisc'] - ['amount'], ej: "0.00"
    ObjetoImp: '02',
    Impuestos: {
      Traslados: {
        Base: ToFixed<CustomerBill['prForBills'][number]['amount'], 2>, // ej: "1", Precio Unitario por cantidad menosa descuneto sin IVA
        Importe: ToFixed<CustomerBill['prForBills'][number]['iva'], 2>, // ej: "1", Monto del IVA
        Impuesto: '002',
        TasaOCuota: ToFixed<PayrollId['defaults']['iva'], 6>, // format: divide by 100 before toFixed, ej: '0.160000', Porcentaje del IVA a 6 dígitos
        TipoFactor: 'Tasa',
      }[],
      Retenciones: {
        Base: ToFixed<CustomerBill['prForBills'][number]['amount'], 2>, // ej: "1", Precio Unitario por cantidad menosa descuneto sin IVA
        Importe: ToFixed<CustomerBill['prForBills'][number]['retIsr'], 2>, // ej: "1", Monto de la retención
        Impuesto: '001' | '002',
        TasaOCuota: ToFixed<PayrollId['defaults']['isrRetention'], 6>, // format: divide by 100 before toFixed, ej: "0.040000", % de Retención
        TipoFactor: 'Tasa',
      }[],
    },
  }[],
  Impuestos: {
    TotalImpuestosTrasladados: ToFixed<CustomerBill['totals']['iva'], 2>, // ej: "1.00"
    TotalImpuestosRetenidos: ToFixed<CustomerBill['totals']['retIsr'], 2>, // ej: "1.00"
    Retenciones: Pick<BillingJsonVersion4['Conceptos'][number]['Impuestos']['Retenciones'][number], 'Importe' | 'Impuesto'>[],
    Traslados: BillingJsonVersion4['Conceptos'][number]['Impuestos']['Traslados'],
  },
};